import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faMapMarkerAlt, faSubway, faCar, faWheelchair, faBus, faTrain } from "@fortawesome/free-solid-svg-icons";

import Authenticated from 'Components/Layouts/Authenticated';
import CmsElement from "Components/Utilities/CmsElement";
import {Loading} from "Components/Partials";
import {RenderWYSIWYG} from "Components/Form";

import {getRecordValue} from "Services/CmsHelpers";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { Container } from "Components/Utilities";
import {Link as DomLink} from "react-router-dom";
import JoinUs from 'Components/Partials/JoinUs';

export default class FAQ extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'faq';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var allowUpdate
     * @type {boolean}
     */
    allowUpdate = false;

    /**
     * @var state
     */
    state = {
        working: true,
        openSections: {},
        selectedCategory: 'All Questions'
    };

    toggleSection = (index) => {
        this.setState(prevState => ({
            openSections: {
                ...prevState.openSections,
                [index]: !prevState.openSections[index]
            }
        }));
    };

    selectCategory = (category) => {
        this.setState({ selectedCategory: category });
    };
    render () {
        const { working, records } = this.state;
        const content = {};
        let faq = [];

        if (records) {
            records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'content')
                .forEach(item => {
                    content[getRecordValue(item, 'title')] = getRecordValue(item, 'content');
                });

            // Build FAQ array and capture category for each question (fallback to 'Other')
            faq = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'question')
                .map(item => ({
                    question: getRecordValue(item, 'title'),
                    answer: getRecordValue(item, 'content'),
                    category: (getRecordValue(item, 'category') || getRecordValue(item, 'group') || 'Other')
                }));
        }

        // Compute category counts and list
        const categoryCounts = {};
        faq.forEach(q => {
            const c = q.category || 'Other';
            categoryCounts[c] = (categoryCounts[c] || 0) + 1;
        });

        const categories = [ 'All Questions', ...Object.keys(categoryCounts) ];

        const filteredFaq = (this.state.selectedCategory === 'All Questions')
            ? faq
            : faq.filter(q => q.category === this.state.selectedCategory);

        return (
            <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                {working && <Loading />}

                {!working && (
                    <>
                        {/*<div className={ "py-8 lg:py-12 space-y-6 text-center mx-auto text-app-blue" }>*/}
                        {/*    <div className={ "text-3xl text-app-blue font-bold" }>*/}
                        {/*        FAQ*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="bg-gray-100 py-12">
                            <Container>
                                <div className="text-center mb-6">
                                    <h2 className="text-3xl font-bold text-app-blue">Venue & Accessibility</h2>

                                </div>
                                <h3 className="w-full mt-10 text-lg md:text-2xl font-semibold text-[#51A0DC] text-left">How to find us</h3>
                                <div className="flex flex-col lg:flex-row gap-6 items-start">
                                    <div className="w-full lg:w-2/3">
                                        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                            <div className="aspect-w-16 aspect-h-9">
                                                <iframe
                                                    className="w-full h-full"
                                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.347434497204!2d-0.1291806842294922!3d51.49947957963392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604c5d5b5b5b5%3A0x5b5b5b5b5b5b5b5b!2sQEII%20Centre!5e0!3m2!1sen!2sus!4v1631542618471!5m2!1sen!2sus"
                                                />
                                            </div>
                                        </div>

                                        {/* Address moved under the map */}
                                        <div className="p-4 rounded-lg mt-4">
                                            <div className="flex items-start gap-3">
                                                <div className="text-[#51A0DC] mt-1">
                                                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                                                </div>
                                                <div>
                                                    <h3 className="font-bold text-[#51A0DC]">Address</h3>
                                                    <div className="text-sm text-app-black">
                                                        <strong>Queen Elizabeth II Centre</strong>
                                                        <br />
                                                        Broad Sanctuary<br />
                                                        London<br />
                                                        SW1P 3EE
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <aside className="w-full lg:w-1/3">
                                        <div className="space-y-4">
                                            <div className="p-4 rounded-lg">
                                                <div className="flex items-start gap-3">
                                                    <div className="text-[#51A0DC]  mt-1">
                                                        <FontAwesomeIcon icon={faSubway} />
                                                    </div>
                                                    <div>
                                                        <h3 className="font-bold text-[#51A0DC] ">Nearest Tube</h3>
                                                        <div className="text-sm text-app-black">
                                                            <strong> Westminster</strong> (Jubilee Line)<br />
                                                            <strong>St. James's Park</strong> (Circle & District Lines)
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="p-4 rounded-lg">
                                                <div className="flex items-start gap-3">
                                                    <div className="text-[#51A0DC]  mt-1">
                                                        <FontAwesomeIcon icon={faTrain} />
                                                    </div>
                                                    <div>
                                                        <h3 className="font-bold text-[#51A0DC] ">Nearest Train Station</h3>

                                                        <div className="text-sm text-app-black">
                                                            <strong>Charing Cross</strong> 12 minutes walk. <br />
                                                            <strong>Victoria</strong> 14 minutes walk. <br />
                                                            <strong>Waterloo</strong> 18 minutes walk.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="p-4 rounded-lg">
                                                <div className="flex items-start gap-3">
                                                    <div className="text-[#51A0DC]  mt-1">
                                                        <FontAwesomeIcon icon={faBus} />
                                                    </div>
                                                    <div>
                                                        <h3 className="font-bold text-[#51A0DC] ">Nearest Bus Stop</h3>
                                                        <div className="text-sm text-app-black">
                                                            Bus routes stop near Westminster and Victoria; check local TfL guides for current routes and accessibility information.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="p-4 rounded-lg">
                                                <div className="flex items-start gap-3">
                                                    <div className="text-[#51A0DC]  mt-1">
                                                        <FontAwesomeIcon icon={faCar} />
                                                    </div>
                                                    <div>
                                                        <h3 className="font-bold text-[#51A0DC] ">By Car</h3>
                                                        <div className="text-sm text-app-black">
                                                            <strong>Parking</strong> is available at the Q-Park Victoria, which is an 8-minute walk from the Centre.
                                                            <br /><br />
                                                            <strong>Blue badge holders</strong> are permitted to park on the QEII Centre forecourt free of charge. Call ahead on +44 20 7798 4000 to enquire.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </aside>
                                </div>
                            </Container>
                        </div>

                        {/* FAQ Section - new green style under the map */}
                        <div style={{ backgroundColor: '#A7F0BA', color: '#044317' }} className="py-10">
                            <Container>
                                <div className="text-center mb-6">
                                    <h2 className="text-3xl font-bold text-app-blue">Frequently Asked Questions</h2>
                                </div>
                                <div className="flex gap-6 lg:gap-12 items-start">
                                    {/* Categories panel */}
                                    <div className="hidden lg:block w-1/4">
                                        <div style={{ backgroundColor: 'rgba(255,255,255,0.85)' }} className="rounded-xl p-4">
                                            <div className="mb-4 font-bold" style={{ color: '#044317' }}>Categories</div>
                                            <ul className="space-y-3 text-sm">
                                                { /* dynamically render categories with counts */ }
                                                { (['All Questions', ...Object.keys(categoryCounts)]).map((cat) => {
                                                    const isAll = cat === 'All Questions';
                                                    const count = isAll ? faq.length : (categoryCounts[cat] || 0);
                                                    const selected = this.state.selectedCategory === cat;
                                                    return (
                                                        <li key={`cat-${cat}`}>
                                                            <button
                                                                onClick={() => this.selectCategory(cat)}
                                                                className="w-full text-left px-3 py-2 rounded-md flex justify-between items-center"
                                                                style={{
                                                                    backgroundColor: selected ? '#EAF9EA' : 'transparent',
                                                                    color: '#044317'
                                                                }}
                                                            >
                                                                <span className="truncate">{cat}</span>
                                                                <span className="ml-2 text-xs text-app-black">{count}</span>
                                                            </button>
                                                        </li>
                                                    );
                                                }) }
                                            </ul>
                                        </div>
                                    </div>

                                    {/* FAQ items */}
                                    <div className="w-full lg:w-3/4">
                                        {/* render filtered FAQ list according to selectedCategory */}
                                        {filteredFaq && filteredFaq.length > 0 ? this.renderFAQSection(filteredFaq) : (
                                            <div className="p-6 rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.8)', color: '#044317' }}>
                                                <p className="font-semibold">No FAQs available for this category.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Container>
                        </div>

                        {/*<div className="max-w-4xl mx-auto py-10 px-5 md:px-10">*/}
                            {/*<div className="flex justify-center pb-4">*/ }
                            {/*    <img*/ }
                            {/*        src={ asset ( 'images/mini-logo.png' ) }*/ }
                            {/*        alt="Logo"*/ }
                            {/*        className="block w-20 align-self-center"*/ }
                            {/*    />*/ }
                            {/*</div>*/ }

                            {/*<div className="text-center">*/}
                            {/*    <RenderWYSIWYG*/}
                            {/*        className="text-black"*/}
                            {/*        content={ content[ 'Welcome Text' ] ?? '' }*/}
                            {/*    />*/}
                            {/*</div>*/}

                            {/*<p className={"text-app-blue text-center text-xl"}>*/}
                            {/*    Please find our frequently asked questions below.*/}
                            {/*    If your query isn't answered please contact us at*/}
                            {/*    {" "}*/}
                            {/*    <a href="mailto:healthcaresymposium@bupa.com" className="text-app-blue text-xl cursor-pointer" >*/}
                            {/*        healthcaresymposium@bupa.com*/}
                            {/*    </a>.*/}

                            {/*</p>*/}
                        {/*</div>*/}

                        {/*{ this.renderFAQSection ( faq ) }*/}
                    </>
                ) }
                <JoinUs />
            </Authenticated>
        );
    }

    renderFAQSection(records) {
        return (
            <Container>
            <section className="grid grid-cols-1 gap-y-3 divide-y border-t-1 border-gray-200">
                {records.map((item, key) => (
                    <details
                        className="group py-1 text-md p-5 text-left"
                        key={`question-${key}`}
                    >
                        <summary
                            className="flex cursor-pointer flex-row item-left justify-between py-1 marker:[font-size:0px] p-5 text-app-black"
                            onClick={() => this.toggleSection(key)}
                        >
                            {item.question}
                            <FontAwesomeIcon
                                icon={this.state.openSections[key] ? faChevronUp : faChevronDown}
                                className="mr-2 text-app-black"
                            />
                        </summary>

                        <p className="font-mediuml text-left text-sm p-5 text-app-black">
                            <RenderWYSIWYG content={item.answer} className="text-app-black" />
                        </p>

                        {item.question === 'What is the venue location?' && (
                            <div className={ "p-5 w-full lg:w-1/2 flex text-white flex-col justify-center h-[40em]" }>
                                <div className="aspect-w-1 aspect-h-1">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.347434497204!2d-0.1291806842294922!3d51.49947957963392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604c5d5b5b5b5%3A0x5b5b5b5b5b5b5b5b!2sQEII%20Centre!5e0!3m2!1sen!2sus!4v1631542618471!5m2!1sen!2sus"
                                    />
                                </div>
                            </div>
                        )}
                    </details>
                ))}
            </section>
        </Container>
        );
    }
}
